var ellipsis = "\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n";
export { ellipsis };
